const SESSION_KEY = 'auth_session'; // localStorage에 저장될 단 하나의 키

// --- 암호화/복호화 함수 (Base64 사용) ---
function encode(str) {
    // btoa는 UTF-8 문자를 처리하지 못할 수 있으므로, 인코딩 과정을 추가합니다.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
        return String.fromCharCode('0x' + p1);
    }));
}

function decode(str) {
    try {
        const decoded = atob(str);
        return decodeURIComponent(decoded.split('').map(c => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    } catch (e) {
        console.error("Failed to decode session data", e);
        return null;
    }
}

// --- 세션 객체를 관리하는 내부 함수 ---

// 전체 세션 객체를 읽고 복호화하는 함수
function getSession() {
    const encryptedSession = localStorage.getItem(SESSION_KEY);
    if (!encryptedSession) {
        return null;
    }
    const decryptedSessionStr = decode(encryptedSession);
    if (!decryptedSessionStr) {
        return null;
    }
    return JSON.parse(decryptedSessionStr);
}

// 전체 세션 객체를 암호화하여 저장하는 함수
function saveSession(sessionData) {
    if (!sessionData) {
        localStorage.removeItem(SESSION_KEY);
        return;
    }
    const sessionStr = JSON.stringify(sessionData);
    const encryptedSession = encode(sessionStr);
    localStorage.setItem(SESSION_KEY, encryptedSession);
}


// --- 기존 인터페이스를 유지하는 export 함수들 ---

/**
 * 인증 정보 객체의 일부를 설정합니다.
 * @param {string} name - 설정할 속성 이름 (예: 'accessToken', 'user')
 * @param {any} value - 설정할 값
 * @param {Date | number} expires - 전체 세션의 만료 시간
 */
export function setCookie(name, value, expires) {
    const session = getSession() || {}; // 기존 세션 가져오기

    if (value === null || value === undefined) {
        delete session[name]; // 값이 없으면 해당 속성 삭제
    } else {
        let expiryTimestamp = null;
        if (expires instanceof Date) {
            expiryTimestamp = expires.getTime();
        } else if (typeof expires === 'number') {
            expiryTimestamp = new Date().getTime() + (expires * 1000);
        }

        // 각 아이템이 자신의 값과 만료 시간을 가집니다.
        session[name] = {
            value: value,
            expiresAt: expiryTimestamp,
        };
    }

    saveSession(session);
}

/**
 * 인증 정보 객체에서 특정 값을 가져옵니다.
 * @param {string} name - 가져올 속성 이름
 * @returns {any | null}
 */
export function getCookie(name) {
    const session = getSession();
    if (!session) return null;

    const item = session[name];
    if (!item) return null;

    // 해당 아이템의 만료 시간을 확인합니다.
    const now = new Date().getTime();
    if (item.expiresAt && now > item.expiresAt) {
        // 만료된 아이템만 삭제하고 세션을 다시 저장합니다.
        delete session[name];
        saveSession(session);
        return null;
    }

    // AuthProvider와의 호환성을 위해 객체는 문자열로 반환합니다.
    if (typeof item.value === 'object' && item.value !== null) {
        return JSON.stringify(item.value);
    }
    return item.value;
}

/**
 * 인증 정보 객체에서 특정 값을 삭제합니다.
 * 실제로는 전체 세션을 다시 저장합니다.
 * @param {string} name - 삭제할 속성 이름
 */
export function deleteCookie(name) {
    const session = getSession();
    if (session && session[name]) {
        delete session[name];
        saveSession(session);
    }
}